import notaApi from '../config/notaApi';

const workAbroadService = {
  // Get user profile
  getProfile: async () => {
    const response = await notaApi.get('/api/nota/work-abroad/profile');
    return response.data;
  },

  // Get overview data
  getOverview: async () => {
    const response = await notaApi.get('/api/nota/work-abroad/overview');
    return response.data;
  },

  // Update personal details
  updatePersonalDetails: async (data) => {
    const response = await notaApi.put('/api/nota/work-abroad/personal-details', data);
    return response.data;
  },

  // Update work history
  updateWorkHistory: async (data) => {
    const response = await notaApi.put('/api/nota/work-abroad/work-history', data);
    return response.data;
  },

  // Get available roles
  getAvailableRoles: async () => {
    const response = await notaApi.get('/api/nota/work-abroad/available-roles');
    return response.data;
  },

  // Update role preferences
  updateRolePreferences: async (data) => {
    const response = await notaApi.put('/api/nota/work-abroad/role-preferences', data);
    return response.data;
  },

  // Upload document
  uploadDocument: async (formData) => {
    const response = await notaApi.post('/api/nota/work-abroad/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Delete document
  deleteDocument: async (documentId) => {
    const response = await notaApi.delete(`/api/nota/work-abroad/documents/${documentId}`);
    return response.data;
  },

  // Record payment
  recordPayment: async (data) => {
    const response = await notaApi.post('/api/nota/work-abroad/payment', data);
    return response.data;
  },

  // Get available companies
  getAvailableCompanies: async () => {
    const response = await notaApi.get('/api/nota/work-abroad/companies');
    return response.data;
  },

  // Book interview
  bookInterview: async (data) => {
    const response = await notaApi.post('/api/nota/work-abroad/interview/book', data);
    return response.data;
  },

  // Payment methods
  createPaymentRequest: async () => {
    const response = await notaApi.post('/api/nota/work-abroad/payment/request');
    return response.data;
  },

  automatePayment: async (requestId) => {
    const response = await notaApi.post('/api/nota/work-abroad/payment/automate', { requestId });
    return response.data;
  },

  getPaymentStatus: async (requestId) => {
    const response = await notaApi.get(`/api/nota/work-abroad/payment/status/${requestId}`);
    return response.data;
  },

  getPaymentRequests: async (params) => {
    const response = await notaApi.get('/api/nota/work-abroad/payment/requests', { params });
    return response.data;
  },

  // Change password
  changePassword: async (data) => {
    const response = await notaApi.put('/api/nota/work-abroad/change-password', data);
    return response.data;
  }
};

export default workAbroadService;
